import template from "./html-preview.html";
import {htmlPreviewController} from "./html-preview.controller";
import "./html-preview.scss";

export const htmlPreviewComponent = {
    template,
    controller: htmlPreviewController,
    controllerAs: "preview",
    bindings: {
        prWidth: "@",
        prHeight: "@",
        index: "@",
        background: "@",
        videoBackground: "@",
        videoOverlay: "@",
        areas: "@",
        gif: "@",
        strip: "@",
        ratio: "@",
        gifSpeed: "@",
        overlay: "@",
        videoTime: "<",
        videoSpeed: "<",
        animationSpeed: "@",
        printerBleed: "@",
        printDpi: "@", //  DPI for 3mm bleed in changeSize (A1–A6, 10×15, 15×20)
        relatedValues: "@",
        ignoreOverflow: "<",
        hideOverlay: "<",
        hideTitle: "<",
        logo: "<",
        logoSize: "<",
        logoPosition: "<",
        logoType: "<",
        bgMode: "<",
        bgColor: "<",
        bgStyle: "<",
        hideLogo: "<",
        hideDefaultLogo: "<",
        single: "<",
        boomerang: "<",
        video: "<",
        logosArr: "=",
        hideGifIcon: "<",
        hidePhotoIcon: "<",
        hideBoomerangIcon: "<",
        hideVideoIcon: "<",
        hideScene: "<",
        transparency: "<",
        scenes: "<",
        hidePhotoBg: "<",
        badgeActive: "<",
        liveViewOpacity: "@",
        margin: "<",
        showTitle: "<",
        screen: "@",
        aiFeature: "<",
        aiOverlay: "<",
        mirror: "<",
        videoMode: "<",
        textColor: "@"
    }
};



// WEBPACK FOOTER //
// ./sources/components/common/html-preview/html-preview.component.js